import {
  FETCH_SHOP_COLLECTION_REQUEST,
  FETCH_SHOP_COLLECTION_SUCCESS,
  FETCH_SHOP_COLLECTION_FAILURE,
  UPDATE_SHOP_COLLECTION
} from '../../actionTypes/shopCollectionActionTypes'

const fetchShopCollectionRequest = payload => {
  const { partNumber, localisation = {} } = payload
  const action = {
    type: FETCH_SHOP_COLLECTION_REQUEST,
    payload: {
      type: 'shopCollection',
      partNumber,
      localisation
    }
  }
  return action
}

const fetchShopCollectionSuccess = payload => {
  const action = {
    type: FETCH_SHOP_COLLECTION_SUCCESS,
    payload
  }
  return action
}

const fetchShopCollectionFailure = ({ partNumber, errorDetail }) => {
  const action = {
    type: FETCH_SHOP_COLLECTION_FAILURE,
    payload: { partNumber, errorDetail: errorDetail.toString() }
  }
  return action
}

const updateShopCollection = payload => {
  const action = {
    type: UPDATE_SHOP_COLLECTION,
    payload
  }
  return action
}

export { fetchShopCollectionRequest, fetchShopCollectionSuccess, fetchShopCollectionFailure, updateShopCollection }
